import AddressDisplay from 'common/components/address/AddressDisplay';

import PickupDisplay from './customer/PickupDisplay';

const CustomerDetails = (props) => {
  const { order } = props;
  const { billTo, shipTo, pickupBy, carrierPickupLocation } = order;
  return (
    <div className="c7-order__customer-detail">
      <h4>Customer information</h4>
      <div>
        {order.orderDeliveryMethod === 'Carry Out' && (
          <p>
            <strong>Carry Out</strong>
          </p>
        )}
        {order.orderDeliveryMethod === 'Pickup' && (
          <span>
            <strong>Pickup By</strong>
            <br />
            <PickupDisplay address={pickupBy} />
          </span>
        )}
        {order.orderDeliveryMethod === 'Ship' && (
          <span>
            <strong>Shipping Address</strong>
            <br />
            <AddressDisplay address={shipTo} />
            {carrierPickupLocation && (
              <>
                <br />
                <br />
                <strong>Local Pickup Location</strong>
                <br />
                <AddressDisplay address={carrierPickupLocation} />
              </>
            )}
          </span>
        )}
        {billTo && (
          <span>
            <strong>Billing Address</strong>
            <br />
            <AddressDisplay address={billTo} />
          </span>
        )}
      </div>
    </div>
  );
};

export default CustomerDetails;
